import { http } from '@/services'

export const documentActions = {
  methods: {
    markInStorage () {
      if (!this.selected.length) return
      var documentIds = this.selected.map(doc => doc.id)
      var data = {action: 'in_storage', data: documentIds}

      http.patch('paper_documents_list', data).then(
      response => {
        this.$emit('update')
        this.selected = []
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    },
    markSentToUser () {
      if (!this.selected.length) return
      var documentIds = this.selected.map(doc => doc.id)
      var data = {action: 'sent_to_user', data: documentIds}

      http.patch('paper_documents_list', data).then(
      response => {
        this.$emit('update')
        this.selected = []
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    },
    markSentToBusiness () {
      if (!this.selected.length) return
      var documentIds = this.selected.map(doc => doc.id)
      var data = {action: 'sent_to_business', data: documentIds}

      http.patch('paper_documents_list', data).then(
      response => {
        this.$emit('update')
        this.selected = []
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    },
    markSentToStorage () {
      if (!this.selected.length) return
      var documentIds = this.selected.map(doc => doc.id)
      var data = {action: 'sent_to_storage', data: documentIds}

      http.patch('paper_documents_list', data).then(
      response => {
        this.$emit('update')
        this.selected = []
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    }
  }
}
